<div class="card">
  <app-grid-server-side
    [storageKey]="pageConfig.storageKey"
    [defaultExcelExportParams]="excelExportParams"
    [excelStyles]="excelStyles"
    [colDefs]="$any(colDefs())"
    [rowData]="alertRows"
    [totalRows]="totalRows()"
    [maxBlocksInCache]="maxBlocksInCache"
    [gridOptions]="gridOptions"
    [pageTitle]="pageConfig.pageTitle"
    [suppressRowClickSelection]="true"
    [serverSideDatasource]="dataSource()"
    [getRowId]="getRowId"
    [paginationPageSize]="defaultPageSize"
    [cacheBlockSize]="cacheBlockSize"
    (gridReady)="onGridReady($event)"
    (select)="selectInboxAlerts($event)"
    (search)="onSearch($event)"
  >
    <div class="grid-controls-middle d-flex justify-content-end gap-12">
      <app-button
        text="Mark All as Read"
        iconClass="icon ic-checkmark-circle-20"
        (clickBtn)="markAllRead()"
      />
    </div>

    <div class="grid-controls-end d-flex justify-content-end gap-12">
      @if (checkedInboxAlerts.length) {
        <div ngbDropdown [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']" class="dropdown">
          <app-button
            ngbDropdownToggle
            id="bulk-actions-dd"
            text="Actions"
            iconClass="icon ic-select-20"
            [iconLast]="true"
          />

          <div
            ngbDropdownMenu
            aria-labelledby="bulk-actions-dd"
            class="common-dropdown-menu dropdown-menu dropdown-menu-right"
          >
            <button ngbDropdownItem (click)="bulkMarkRead()">
              <i class="icon ic-checkmark-circle-20"></i>
              <span>Mark as Read</span>
            </button>

            @if (isMarkAsNeedAttentionAllowed) {
              <button ngbDropdownItem (click)="bulkMarkRequireAttention()">
                <i class="icon ic-info-circle-20"></i>
                <span>Mark as Require Attention</span>
              </button>
            }

            <button ngbDropdownItem (click)="bulkArchive()">
              <i class="icon ic-archive-20"></i>
              <span>Archive</span>
            </button>

            <!--            <div ngbDropdownItem (click)="bulkIgnore()">-->
            <!--              <i class="icon ic-ignore-20"></i>-->
            <!--              <span>Ignore</span>-->
            <!--            </div>-->

            @if (isPostponeAllowed) {
              <div
                ngbDropdown
                container="body"
                class="dropdown p-0"
                [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
              >
                <button
                  ngbDropdownToggle
                  class="dropdown-item-like dropdown-button d-flex gap-2 border-0 bg-transparent font-weight-normal"
                >
                  <i class="icon ic-clock-20"></i>
                  <span class="flex-grow-1 text-start">Postpone</span>
                  <i class="icon ic-chevron-down-20"></i>
                </button>

                <div
                  ngbDropdownMenu
                  aria-labelledby="bulk-actions-dd"
                  class="common-dropdown-menu dropdown-menu dropdown-menu-right"
                >
                  @for (item of postponeMenu; track $index) {
                    <button ngbDropdownItem (click)="bulkPostpone(item.value)">
                      <span>{{ item.label }}</span>
                    </button>
                  }
                </div>
              </div>
            }

            <button ngbDropdownItem (click)="exportSelectedAlertsToXls()">
              <i class="icon ic-download-20"></i>
              <span>Export to xlsx</span>
            </button>
          </div>
        </div>
      } @else {
        <app-button
          title="Export"
          btnColor="white"
          iconClass="icon ic-download-20"
          [isDisabled]="!totalRows"
          (clickBtn)="exportAlertsList(false, ExportTypeEnum.EXCEL)"
        />
      }
    </div>
  </app-grid-server-side>
</div>

<app-common-offcanvas
  [opened]="$showDetails()"
  (close)="closeDetails()"
>
  <div class="header">
    <app-offcanvas-pagination-title
      [title]="$selectedAlert()?.type | alertsType"
      [currentIndex]="currentAlertIndex"
      [total]="totalRows()"
      (moveToPrevious)="previousAlert()"
      (moveToNext)="nextAlert()"
    />
  </div>

  <app-alert-details-content
    [alertSetter]="$selectedAlert()!"
    (updateAlert)="updateAlertGridRow($event)"
    (close)="this.removeQueryParams()"
  />
</app-common-offcanvas>
